import { subscribeChatHubEvent } from "@/domains/offline/chat/chatHubManager";
import { authMeQueryKey } from "@/domains/shared/hooks/useAuth";
import type { IUser } from "@/domains/shared/models/IUser";
import { Roles } from "@/domains/shared/models/roles";
import { forceLogoutSuperseded } from "@/domains/shared/services/sessionSuperseded";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

type SessionRevokedPayload = {
  sessionGeneration?: number;
};

export function useSessionRevocation(role?: string, emailVerified?: boolean, enabled: boolean = true) {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled || role !== Roles.Therapist || emailVerified !== true) {
      return;
    }

    const unsubscribe = subscribeChatHubEvent("SessionRevoked", (payload) => {
      const revoked = payload as SessionRevokedPayload;
      const user = queryClient.getQueryData<IUser>(authMeQueryKey);
      const currentGen = user?.sessionGeneration ?? 0;
      const nextGen = revoked?.sessionGeneration ?? 0;

      if (nextGen !== currentGen) {
        void forceLogoutSuperseded();
      }
    });

    return unsubscribe;
  }, [enabled, role, emailVerified, queryClient]);
}
